const typeIcons: Record<string, string> = {
  "Pessoa física": "ri-user-line",
  "Pessoa jurídica": "ri-building-line",
  "Órgão público": "ri-government-line",
  "Secretaria municipal": "ri-building-4-line",
  "Órgão ambiental": "ri-leaf-line",
  "Empresa executora": "ri-briefcase-line",
  "Consultoria ambiental": "ri-lightbulb-line",
  "Condomínio": "ri-community-line",
  "Loteadora": "ri-home-gear-line",
  "Associação/comunidade": "ri-group-line",
  "Unidade interna": "ri-team-line",
  "Outro": "ri-more-line",
};

const typeColors: Record<string, string> = {
  "Pessoa física": "bg-secondary-100 text-secondary-700",
  "Pessoa jurídica": "bg-accent-100 text-accent-700",
  "Órgão público": "bg-primary-100 text-primary-700",
  "Secretaria municipal": "bg-primary-50 text-primary-600",
  "Órgão ambiental": "bg-primary-100 text-primary-700",
  "Empresa executora": "bg-accent-50 text-accent-600",
  "Consultoria ambiental": "bg-secondary-50 text-secondary-600",
  "Condomínio": "bg-background-100 text-foreground-600",
  "Loteadora": "bg-accent-100 text-accent-700",
  "Associação/comunidade": "bg-secondary-100 text-secondary-700",
  "Unidade interna": "bg-primary-50 text-primary-600",
  "Outro": "bg-background-100 text-foreground-500",
};

interface PartyTypeBadgeProps {
  type: string;
}

export default function PartyTypeBadge({ type }: PartyTypeBadgeProps) {
  const icon = typeIcons[type] || "ri-more-line";
  const colors = typeColors[type] || "bg-background-100 text-foreground-500";
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${colors}`}>
      <i className={`${icon} w-3 h-3 flex items-center justify-center`} />
      {type}
    </span>
  );
}